import React from 'react';
import { moneyFormatFromCents } from "../../utilities/moneyFormat.js";
import MoneyComponent from "react/elements/MoneyComponent";


export default function SpentAndBudgetedSummary({
	                                                incomeWord = 'Income',
	                                                income,
	                                                budgetedWord = 'Budgeted',
	                                                budgeted,
	                                                spent,
	                                                spentWord = 'Spent'
                                                }) {

	return (
		<div className='budget_summary'>
			{income !== undefined &&
			<div className='income'>
				<span className='title'>
					{incomeWord}
				</span>
				<span className='amount'>
					<MoneyComponent amount={income} />
				</span>
			</div>
			}
			{budgeted !== null &&
			<div className='budgeted'>
				<span className='title'>
					{budgetedWord}
				</span>
				<span className='amount'>
					<MoneyComponent amount={budgeted} />
				</span>
			</div>
			}
			<div className='spent'>
				<span className='title'>
					{spentWord}
				</span>
				<span className='amount'>
					<MoneyComponent amount={spent} />
				</span>
			</div>
		</div>
	);
}